define('lib/Podio.UI.FlashMessage',['require','jquery','lib/Podio.Router','lib/Podio.UI.PushNotifications','lib/Podio.Event','lib/Podio.Utils','jst!notifications/push/sticky_notification','jst!notifications/push/flash_notification'],function(require) {

  var $ = require('jquery');
  var router = require('lib/Podio.Router');
  var pushNotifications = require('lib/Podio.UI.PushNotifications');
  var podioEvent = require('lib/Podio.Event');
  var podioUtils = require('lib/Podio.Utils');

  var jstStickyNotification = require('jst!notifications/push/sticky_notification');
  var jstFlashNotification = require('jst!notifications/push/flash_notification');

  var icons = {
    'error' : 'icon-16 icon-16-red-warning-triangle',
    'notice' : 'icon-16 icon-16-single-green-tick'
  };

  function onDomReady() {
    helpers.replaceFlashMessages();
    helpers.showHashFlashMessage();
    podioEvent.bind(podioEvent.Types.onTransportGlobalSuccess, onTransportGlobalSuccess);
    podioEvent.bind(podioEvent.Types.onTransportGlobalError, onTransportGlobalError);
  }

  var helpers = {
    replaceFlashMessages: function _replaceFlashMessages() {
      $('.flash-message').each(function() {
        var elmItem = $(this);
        var type = elmItem.attr('class').replace('flash-message hidden', '').trim();
        show(elmItem.text(), type);
        elmItem.remove();
      });
    },

    showHashFlashMessage: function _showHashFlashMessage() {
      var hashQuery = router.getHashes();
      var urlQuery = podioUtils.querystring();
      var message = hashQuery['msg'] || urlQuery['msg'];
      if (message) {
        message = decodeURIComponent(message);
        show(message, 'confirmation');
        router.goToHashRoute('');
      }
    }
  };

  // Available styles: notice, warning, error
  function show(message, style, options) {
    if(!style){
      style = 'notice';
    }

    options = typeof(options) != 'undefined' ? options : {};
    var sticky;
    if(options.sticky === true || options.sticky === false) {
      sticky = options.sticky;
    } else {
      sticky = (style == 'error');
    }

    var template = (sticky ? jstStickyNotification : jstFlashNotification);
    var html = template({
      style: style,
      icon : icons[style],
      text: message
    });

    pushNotifications.render(html, null, {
      noSound: true,
      sticky: sticky
    });
  }

  function disableErrorMessages() {
    this.show = function() {
      return false;
    };
  }

  function enableErrorMessages() {
    this.show = show;
  }

  function onTransportGlobalError(e, message, options) {
    options = options || {};

    if (!options.dismissGenericErrorMessage) {
      show(message, 'error', options);
    }
  }

  function onTransportGlobalSuccess(e, message, options) {
    show(message, 'notice', options);
  }

  podioEvent.bind(podioEvent.Types.init, onDomReady);

  return {
    show: show,
    enableErrorMessages: enableErrorMessages,
    disableErrorMessages :disableErrorMessages
  };

});

